<div class="center">
  <div class="d-flex">
    <kh-labeled-field [controlValue]="controlValue" [placeholder]="placeholder" class="min-search flex-grow-1"></kh-labeled-field>

    <button class="border-radius-sm search-button" (click)="search()" [attr.aria-label]="'SEARCH_FIELD.SEARCH' | translate ">
      <fa-icon [icon]="['fas', 'search']" size="2x" class="white"></fa-icon>
    </button>
  </div>
</div>
